import { deviceDataFormatted, getSingleDevFormatted } from '@/js/utils';
import Vue from 'vue';

const SET_DEVICE_DATA = (state, deviceInfo) => {
  state.deviceData = deviceDataFormatted(deviceInfo);
};

const SET_PROMISE = (state, promise) => {
  state.promise = promise;
};

const UPDATE_DEVICE_DATA = (state, dataList) => {
  if (Array.isArray(dataList)) {
    dataList.forEach((dev) => {
      if (dev) {
        const deviceIndex = state.deviceData.findIndex(
          (d) => d.dev_id === dev.dev_id
        );
        if (deviceIndex !== -1) {
          Vue.set(state.deviceData, deviceIndex, getSingleDevFormatted(dev));
        }
      }
    });
  }
};

export default {
  SET_DEVICE_DATA,
  SET_PROMISE,
  UPDATE_DEVICE_DATA,
};
